import { BaseMdl } from './BaseMdl';
import { cast, Castable } from '@bitr/castable';

export class groupMdl {
    group_id: number = 0;
    group_name: string = '';
    user_name: string = '';
    corp_name: string = '';
    office_code_list: string = '';
    pref_num: number = -1;

    constructor(init?: Partial<groupMdl>) {
        Object.assign(this, init);
    }

    public static toJsonDataOnModel(data: any): any {
        return BaseMdl.toJsonOnModel(new groupMdl(), data);
    }
}

export class groupCastMdl extends Castable {
    @cast group_id: number;
    @cast group_name: string;
    @cast user_name: string;
    @cast corp_name: string;
    @cast office_code_list: string;
    @cast pref_num: number;
}

export class groupEditMdl {
    group_id: number = 0;
    group_name: string = '';
    user_name: string = '';
    machine_id: number = 0;

    constructor(init?: Partial<groupEditMdl>) {
        Object.assign(this, init);
    }

    public static toJsonDataOnModel(data: any): any {
        return BaseMdl.toJsonOnModel(new groupEditMdl(), data);
    }
}
